import { useEffect, useState } from "react";
import { Form, Modal, Typography, Checkbox, Flex, Button } from "antd";
import { ClearOutlined } from "@ant-design/icons";

import CustomSelect from "@/components/inputs/CustomSelect";
import { getPluralizedWord } from "@/utils";
import { exportObject, exportObjects } from "@/api/objects";

const { Text } = Typography;

// Окно для экспорта объектов
const ExportObjectsModal = ({
  objects = [],
  fields = [],
  definition,
  visible,
  onSave,
  onCancel,
  onClearAndCancel,
  isSingleObject = false,
  isAdmins = false,
  exportAccessInfo,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fieldsOptions = fields.map((field) => ({
    label: field.name,
    value: field.uuid,
  }));

  const formatOptions = [
    {
      value: "xlsx",
      label: "xlsx",
    },
    {
      value: "csv",
      label: "csv",
    },
  ];

  useEffect(() => {}, []);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      const res = isSingleObject
        ? await exportObject(
            {
              uuid: objects[0]?.uuid,
              definition_uuid: definition,
              ...values,
            },
            isAdmins,
          )
        : await exportObjects(
            {
              objects,
              definition_uuid: definition,
              ...values,
            },
            isAdmins,
          );

      onSave(res);
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () =>
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });

  return (
    <Modal
      maskClosable={false}
      title={isSingleObject ? "Экспорт объекта" : "Экспорт объектов"}
      open={visible}
      onCancel={onCancel}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          {!isSingleObject && (
            <Button
              key="link"
              color="danger"
              variant="link"
              icon={<ClearOutlined />}
              onClick={onClearAndCancel}
              style={{ marginRight: "auto", paddingInline: 0 }}
            >
              Отмена и очистка выбора
            </Button>
          )}

          <Button key="back" onClick={handleCancel}>
            Отмена
          </Button>

          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={onOk}
          >
            Выгрузить
          </Button>
        </div>
      }
    >
      <Flex vertical gap={10}>
        {!!objects.length && !isSingleObject && (
          <>
            <Text>
              Выбрано {objects.length}{" "}
              {getPluralizedWord(objects.length, [
                "объект",
                "объекта",
                "объектов",
              ])}
            </Text>
          </>
        )}
        <Form
          form={form}
          initialValues={{
            fields: fields.map((field) => field.uuid),
            file_type: formatOptions[0].value,
          }}
          layout="vertical"
          onFinish={handleSave}
        >
          {!!fieldsOptions.length && (
            <Form.Item name="fields" label="Укажите поля для выгрузки">
              <Checkbox.Group
                options={fieldsOptions}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 5,
                }}
              ></Checkbox.Group>
            </Form.Item>
          )}

          {!isSingleObject && (
            <Form.Item name="file_type" label="Формат файла">
              <CustomSelect options={formatOptions} />
            </Form.Item>
          )}
          {exportAccessInfo?.hasWarning && (
            <Flex vertical>
              <span>{`Записи, недоступные для редактирования, не будут выгружены.`}</span>{" "}
              <span>{`Из ${exportAccessInfo.total} ${getPluralizedWord(exportAccessInfo.total, ["выбранного объекта", "выбранных объектов", "выбранных объектов"])} ${getPluralizedWord(exportAccessInfo.available, ["будет скачан", "будет скачано", "будет скачано"])} ${exportAccessInfo.available}.`}</span>
            </Flex>
          )}
          {error && <Text type="danger">{error}</Text>}
        </Form>
      </Flex>
    </Modal>
  );
};

export default ExportObjectsModal;
